import { alpha } from '@mui/material';
export var makeStateLayer = function (layerColor) { return ({
    '&:hover, &:active': {
        '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            height: '100%',
            borderRadius: 'inherit',
            top: 0,
            left: 0,
            right: 0,
        },
    },
    '&:hover:after': {
        backgroundColor: alpha(layerColor, 0.08),
    },
    '&:active:after': {
        backgroundColor: alpha(layerColor, 0.12),
    },
}); };
